export const THEME_STORAGE_KEY = 'siteTheme'

export const normalizeTheme = (value) => (value === 'dark' ? 'dark' : 'light')

export function getStoredTheme() {
  try {
    const value = localStorage.getItem(THEME_STORAGE_KEY)
    return normalizeTheme(value)
  } catch {
    return 'light'
  }
}

export function isDarkTheme() {
  return document.documentElement.dataset.theme === 'dark'
}

export function applyTheme(theme) {
  const normalized = normalizeTheme(theme)
  const root = document.documentElement
  root.classList.remove('dark')
  root.dataset.theme = normalized
  try {
    localStorage.setItem(THEME_STORAGE_KEY, normalized)
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent('site-theme-change', { detail: { theme: normalized } }))
}
